import { useCallback, useState } from 'react';

import { getImageFormat } from '../utils/getImageFormat';

const useNotificationImageFormat = (src) => {
  const [loadedImageData, setLoadedImageData] = useState(null);

  const imageFormat = src && loadedImageData?.src === src
    ? loadedImageData.format
    : null;

  const handleImageLoad = useCallback((event) => {
    if (!src) return;

    const { naturalWidth, naturalHeight } = event.currentTarget;
    const format = getImageFormat({ width: naturalWidth, height: naturalHeight });

    if (!format) return;

    setLoadedImageData((prevData) => {
      if (prevData?.src === src && prevData?.format === format) return prevData;

      return { src, format };
    });
  }, [src]);

  return {
    imageFormat,
    handleImageLoad,
  };
};

export default useNotificationImageFormat;
